import { render } from "./Chats.vue?vue&type=template&id=8eab6332&scoped=true"
import script from "./Chats.vue?vue&type=script&lang=js"
export * from "./Chats.vue?vue&type=script&lang=js"

import "./Chats.vue?vue&type=style&index=0&id=8eab6332&scoped=true&lang=css"

import exportComponent from "/home/trit/trit/dev/caspwebapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8eab6332"]])

export default __exports__